import styled from 'styled-components';
import Input from 'gatsby-theme-core/src/components/form-elements/input';

export default styled(Input)`
    border-radius: ${({ theme }) => theme.borderRadius};
`;
